import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_medication_class } from '@/graphql/queries'

export default {
  data() {
    return {
      medicationClassesList: [],
    }
  },
  methods: {
    async fetchMedicationClasses() {
      try {
        const response = await client.graphql({
          query: list_medication_class,
        })

        let responseData = JSON.parse(response.data.list_medication_class)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.medicationClassesList = (responseData.data || []).filter(
            (item) => item.class_status !== "DEACTIVE"
          )
        } else {
          this.medicationClassesList = []
        }
        // console.log(this.medicationClassesList)

      } catch (error) {
        console.error("Error fetching medication classes:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.medicationClassesList = [];
        throw error;
      }
    },
  },
  computed: {
    medicationClassOptions() {
      return this.medicationClassesList.map((medClass) => ({
        text: medClass.class_name,
        value: medClass.class_id,
        title: medClass.class_name,
      }));
    },
  },
};

